export default "__VITE_ASSET__92173498__"